import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { API_ADDR, JSON_CONTENT_TYPE, API_ERROR_MSG } from './config';

@Injectable()
export abstract class BaseService {

  constructor() {
    // TODO: inject a logger someday for better logging
  }

  url() {
    return API_ADDR;
  }

  jsonContentType() {
    return JSON_CONTENT_TYPE;
  }

  extractData(res: Response | any) {
    let body = res.json();
    return body.data || {};
  }

  handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    alert(`${API_ERROR_MSG} (errMsg: "${errMsg}")`);
    // TODO: implement proper error logging
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/base-service.ts